import { render } from "./ProjectsRoadmapChart.vue?vue&type=template&id=ea48573c&ts=true"
import script from "./ProjectsRoadmapChart.vue?vue&type=script&lang=ts"
export * from "./ProjectsRoadmapChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__